export var UI_SDK_CONSTANTS = {};
